module.exports = __webpack_public_path__ + "img/racecourse-barrowdalePark-turf-1450.30c2c15a.svg";